import { render, staticRenderFns } from "./KitFavouriteButton.vue?vue&type=template&id=53fa18c0&scoped=true&"
import script from "./KitFavouriteButton.vue?vue&type=script&lang=ts&"
export * from "./KitFavouriteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa18c0",
  null
  
)

export default component.exports